import { render, staticRenderFns } from "./GoodsAdd.vue?vue&type=template&id=1f2e82d2&scoped=true&"
import script from "./GoodsAdd.vue?vue&type=script&lang=js&"
export * from "./GoodsAdd.vue?vue&type=script&lang=js&"
import style0 from "./GoodsAdd.vue?vue&type=style&index=0&id=1f2e82d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2e82d2",
  null
  
)

export default component.exports